import stylesheet from './DataTablePagination.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export class NXTDataTablePagination extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get hasPrev(): boolean {
        return this.getAttribute('prev') === 'true';
    }

    get hasNext(): boolean {
        return this.getAttribute('next') === 'true';
    }

    get size(): string {
        return this.getAttribute('size') ?? 'md';
    }

    getSizeVariants(): string[] {
        const additionalClasses: string[] = [];
        additionalClasses.push(`pagination-${this.size}`);
        for (const breakpoint of ['md', 'lg', 'xl', 'xxl']) {
            const attributeName = `size-${breakpoint}`;
            if (this.hasAttribute(attributeName)) {
                additionalClasses.push(`pagination-${this.getAttribute(attributeName)}-${breakpoint}-up`);
            }
        }
        return additionalClasses;
    }

    render() {
        const tableContainer = document.createElement('div');
        tableContainer.classList.add('pagination', ...this.getSizeVariants());
        tableContainer.innerHTML = `
            <span class="page-indicator">
                <slot></slot>
            </span>
            <button type="button" class="btn-prev" ${this.hasPrev ? '' : 'disabled="disabled"'}>
                <nxt-icon icon="arrow-back-2"></nxt-icon>
            </button>
            <button type="button" class="btn-next" ${this.hasNext ? '' : 'disabled="disabled"'}>
                <nxt-icon icon="arrow-forward-2"></nxt-icon>
            </button>
        `;
        tableContainer.querySelector('.btn-prev').addEventListener('click', () => {
            this.triggerEvent('prev');
        });
        tableContainer.querySelector('.btn-next').addEventListener('click', () => {
            this.triggerEvent('next');
        });
        return tableContainer;
    }

    triggerEvent(eventType: string) {
        this.dispatchEvent(new CustomEvent(eventType, {
            bubbles: true,
        }));
    }

}

customElements.define('nxt-data-table-pagination', NXTDataTablePagination);
